<div class="content-main bg-black dark:bg-white">
  <!-- Contenedor del Mapa (ocupa toda la pantalla) -->
  <div class="map-container">
    <app-map
      class="h-full w-full"
      [coordinates]="coordinates"
      (assistantSchedule)="assistantSchedule($event)"
      [workshopsFromAssistant]="workshopsFromAssistant"
      (workshopsUpdated)="onWorkshopsUpdated()"
    ></app-map>
  </div>

  <!-- Enlace para descargar la app -->
  <button routerLink="/app-download" class="Btn text-primary">
    <svg class="svgIcon text-white" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
      ></path>
    </svg>
    <span class="icon2"></span>
    <span class="tooltip">Descargar</span>
  </button>
<div class="access-home-container">
    <app-access-home></app-access-home>
</div>

  <div class="btn-open-ai z-10 group relative" *ngIf="!isAssistantVisible" matTooltip="Asistencia Virtual" (click)="toggleAssistant()">
    <img src="../../../../assets/images/juan1.png" alt="Abrir Assistant" class="animate-pulse" />

    <!-- Tooltip -->
    <span
      class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gray-900 text-white text-xs rounded py-1 px-2 absolute bottom-full left-1/2 -translate-x-1/2 mb-2 whitespace-nowrap pointer-events-none"
    >
      Asistencia Virtual Gratuita
    </span>
  </div>

  <!-- Contenedor del Assistant (aparece cuando se activa) -->
  <div class="content-ai" *ngIf="isAssistantVisible" [class.visible]="isAssistantVisible" [class.expandido]="chatExpandido">
    <!-- Botón de expandir/contraer -->
    <div *ngIf="isMobile" class="toggle-button" (click)="alternarChat()">
      <svg
        *ngIf="chatExpandido"
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 animate-bounce text-primary"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
      <svg
        *ngIf="!chatExpandido"
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 animate-bounce text-primary"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
      </svg>
    </div>

    <!-- Botón cerrar (fuera del contenido interno) -->
    <div class="btn-collapse-ai bg-black dark:bg-white" (click)="toggleAssistant()">X</div>

    <!-- Contenido del Assistant -->
    <app-assistant-ai class="assistant-inner rounded-2xl" (workshopsFound)="receiveWorkshops($event)" [selectedWorkshop]="workShop"> </app-assistant-ai>
  </div>
</div>
